module.exports = __webpack_public_path__ + "assets/training-item-upload.ccef6976.svg";